/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

export default class BaseNoiseGroup extends EmberObject {
  magnitude = null;
  previousNoiseGroup = null;

  @computed('previousNoiseGroup', 'magnitude') get spectralDensityMagnitude() {
    var previousNoiseGroup = this.previousNoiseGroup;
    var magnitude = this.magnitude;
    var result = magnitude;
    if (previousNoiseGroup) {
      var previousCircuitSpectralMagnitude = previousNoiseGroup.spectralDensityMagnitude;
      result = previousCircuitSpectralMagnitude.map((item, index) => {
        var val = magnitude[index] * item;
        return val;
      });
    }

    return result;
  }

  @computed('noiseReferredToInputArray', 'previousNoiseGroup') get _spectralNoiseReferredToInputArray() {
    var noiseReferredToInputArray = this.noiseReferredToInputArray;
    var previousNoiseGroup = this.previousNoiseGroup;
    var result = noiseReferredToInputArray;
    if (previousNoiseGroup) {
      var previousSpectralDensityMagnitude = previousNoiseGroup.spectralDensityMagnitude;
      result = noiseReferredToInputArray.map((item, index) => {
        var res = item / previousSpectralDensityMagnitude[index];
        return res;
      });
    }

    return result;
  }

  @computed('_spectralNoiseReferredToInputArray', 'previousNoiseGroup') get totalSpectralNoiseReferredToInputArray() {
    var previousNoiseGroup = this.previousNoiseGroup;
    var spectralNoise = this._spectralNoiseReferredToInputArray;
    var result = spectralNoise;
    if (previousNoiseGroup) {
      var previousTotalSpectralNoiseRTI = previousNoiseGroup.totalSpectralNoiseReferredToInputArray;
      result = spectralNoise.map((item, index) => {
        return Math.sqrt(item * item + previousTotalSpectralNoiseRTI[index] * previousTotalSpectralNoiseRTI[index]);
      });
    }
    return result;
  }

  @computed('totalSpectralNoiseReferredToInputArray', 'spectralDensityMagnitude', 'magnitude')
  get totalSpectralNoiseReferredToOutputArray() {
    //console.time('totalSpectralNoiseReferredToInputArray');
    var totalSpectralNoiseReferredToInputArray = this.totalSpectralNoiseReferredToInputArray;
    //console.timeEnd('totalSpectralNoiseReferredToInputArray');
    var magnitude = this.spectralDensityMagnitude;
    var result = totalSpectralNoiseReferredToInputArray.map((item, index) => {
      return item * magnitude[index];
    });

    return result;
  }
}
